import React from 'react';
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Link, useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export function ChatImageViewer({image, onClose, labels}) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog
			open={Boolean(image)}
			onClose={onClose}
			fullScreen={fullScreen}
			fullWidth
			maxWidth="lg"
			PaperProps={{sx: {borderRadius: {xs: 0, sm: 2}, maxHeight: {xs: '100%', sm: '94vh'}}}}
		>
			<DialogTitle sx={{pr: 6}}>
				{image && (image.title || image.caption || image.sourceTitle || image.alt)}
				<IconButton
					aria-label={labels.closeImage}
					onClick={onClose}
					sx={{position: 'absolute', right: 8, top: 8}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers sx={{p: {xs: 1, sm: 2}, textAlign: 'center', bgcolor: 'grey.50'}}>
				{image ? (
					<>
						<Box
							component="img"
							src={image.url}
							alt={image.alt || image.title || image.caption || ''}
							onError={onClose}
							sx={{display: 'block', width: '100%', maxWidth: '100%', height: {xs: 'calc(100vh - 150px)', sm: 'auto'}, maxHeight: {xs: 'none', sm: '75vh'}, objectFit: 'contain', mx: 'auto'}}
						/>
						{image.sourceUrl ? (
							<Link href={image.sourceUrl} target="_blank" rel="noopener noreferrer" display="inline-block" mt={1.5}>
								{image.sourceLabel || labels.imageSource}<OpenInNewIcon fontSize="small" sx={{ml: 0.5, verticalAlign: 'middle'}} />
							</Link>
						) : null}
					</>
				) : null}
			</DialogContent>
		</Dialog>
	);
}
